/**
 * Production domains that must never enter simulated preview mode, even if a
 * stale build-time REACT_APP_PREVIEW_MODE=true is baked into the bundle.
 */
const PRODUCTION_HOSTS = new Set([
  'santacruzstrength.com',
  'www.santacruzstrength.com',
]);

/**
 * Single source of truth for runtime preview state.
 *
 * - santacruzstrength.com / www.santacruzstrength.com → always false.
 * - preview.emergentagent.com, localhost, 127.0.0.1   → respects the
 *   build-time REACT_APP_PREVIEW_MODE flag.
 * - A normal production build with the flag set to "false" → false everywhere.
 *
 * Every mutation guard, form, notice, and attribution call must go through this
 * resolver.  No other preview rule may compete with it.
 */
export function isEffectivePreview() {
  if (typeof window !== 'undefined' && PRODUCTION_HOSTS.has(window.location.hostname)) {
    return false;
  }
  return process.env.REACT_APP_PREVIEW_MODE === 'true';
}

/** @deprecated - use isEffectivePreview() for runtime checks.  Retained only
 *  for pure-function unit tests that pass an explicit string value. */
export function isPreviewMode(value = process.env.REACT_APP_PREVIEW_MODE) {
  return value === 'true';
}

export class PreviewMutationBlockedError extends Error {
  constructor(action = 'This action') {
    super(`${action} is disabled in preview mode. No data was sent or stored.`);
    this.name = 'PreviewMutationBlockedError';
    this.code = 'PREVIEW_MUTATION_BLOCKED';
  }
}

export function isMutationMethod(method = 'get') {
  return ['post', 'put', 'patch', 'delete'].includes(String(method).toLowerCase());
}

export function assertMutationAllowed(action, previewValue) {
  const effective = arguments.length >= 2 ? isPreviewMode(previewValue) : isEffectivePreview();
  if (effective) throw new PreviewMutationBlockedError(action);
  return true;
}

export function resolveApiBaseUrl(value) {
  const resolved = arguments.length === 0 ? process.env.REACT_APP_BACKEND_URL : value;
  if (typeof resolved !== 'string' || !resolved.trim()) return '';
  return resolved.trim().replace(/\/+$/, '');
}

export function buildApiUrl(path, baseUrl = resolveApiBaseUrl()) {
  const safePath = String(path || '').startsWith('/') ? String(path || '') : `/${path || ''}`;
  return `${baseUrl}${safePath}`;
}

export function validateProductionBackendUrl({
  backendUrl = process.env.REACT_APP_BACKEND_URL,
  nodeEnv = process.env.NODE_ENV,
  previewValue,
} = {}) {
  const effective = arguments.length > 0 && 'previewValue' in (arguments[0] || {})
    ? isPreviewMode(previewValue)
    : isEffectivePreview();
  if (nodeEnv === 'production' && !effective && !resolveApiBaseUrl(backendUrl)) {
    throw new Error('REACT_APP_BACKEND_URL is required for a production build. Use npm run build:preview for a no-send review build.');
  }
  return true;
}
